import { Key, useEffect, useState } from "react";
import styles from "./EntrepreneurAccountOrders.module.css";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import ModalConfirmarRetirada from "../ModalConfirmarRetirada/ModalConfirmarRetirada";
import ProdutoItem from "../Carrinho/Itens";

import { useTranslation } from "react-i18next";

import api from "../../utils/axios/api";
import { Produto } from "../CardProduto/CardProduto";

//TODO: pegar pedidos do backend
//TODO: order tem data de compra e data de entrega? e tipo (entrega ou delivery?) e código de rastreio?

const orderStatus = [
  "PAYED",
  "SEPARATE",
  "SENT",
  // "RECEIVED",
  // "PAYMENT_PENDING"
]

const EntrepreneurAccountOrders = () => {
  const { t, i18n } = useTranslation();
  const [orders, setOrders] = useState<any[]>([]);
  const [showProductList, setShowProductList] = useState<boolean[]>(
    Array.from({ length: orders.length }, () => false)
  );
  const [showModalConfirmPickup, setShowModalConfirmPickup] =
    useState<boolean>(false);
  const [orderToConfirmPickup, setOrderToConfirmPickup] =
    useState<any | null>(null);

  // Função para buscar os pedidos do backend
  const fetchOrders = async () => {
    try {
      let entrepeneurId = localStorage.getItem("entrepeneurId");

      if (!entrepeneurId) {
        const userResponse = await api.get("/user/id/token");
        entrepeneurId = userResponse.data.entrepeneur?.id ?? null;
        if (entrepeneurId) localStorage.setItem("entrepeneurId", entrepeneurId);
      }

      if (!entrepeneurId) return;

      const response = await api.get(`/order/entrepeneur/${entrepeneurId}`);

      const formattedOrders = response.data.map((order: any) => ({
        ...order,
        createdAt: order.createdAt ? new Date(order.createdAt) : null,
        date: order.date ? new Date(order.date) : null,
        product_order: order.product_order || [], // Garante que é um array
      }));
      setOrders(formattedOrders);
      setShowProductList(Array.from({ length: formattedOrders.length }, () => false));
    } catch (error) {
      console.error("Erro ao buscar pedidos:", error);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleToggleShowProducts = (index: number) => {
    setShowProductList((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const handleConfirmPickup = async () => {
    //TODO: verificar o funcionamento depois
    try {
      await api.put(`/order/status/${orderToConfirmPickup!.id}`, { status: "ENTREGUE" });
    }
    catch (error) {
      console.error(error);
    }
    setShowModalConfirmPickup(false);

  };

  // useEffect(() => {
  //   const getOrders = async () => {
  //     const response = await api.get(`/order/entrepeneur/${entrepeneurId}`);
  //     setOrders(response.data);
  //   }
  //   getOrders();
  // }, []);

  const currencyLocalFormat = (value: number) => {
    return value.toLocaleString(i18n.language || "pt-BR", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };

  return (
    <div className={styles.mainContainer}>
      <h1>{t(`accountMenu.orders`)}</h1>
      <div className={styles.container}>
        <>
          {orders.map((order, index) => {
            return (
              <div key={order.id} className={styles.orderContainer}>
                <h2>{t(`accountMenu.orderData`)}</h2>
                <div className={styles.orderInfoContainer}>
                  <div>
                    <h3>
                      {t(`accountMenu.order`)} #{order.id}
                    </h3>
                    <p>
                      <strong>{t("pedidos.nome")}</strong> {order.client.user.name}
                    </p>
                    <p>
                      <strong>{t("pedidos.dataCompra")}</strong>{" "}
                      {order.createdAt ? `${order.createdAt.getDate()}/${order.createdAt.getMonth() + 1}/${order.date.getFullYear()}` : "Erro"}
                    </p>
                    <p>
                      <strong>{t("pedidos.dataEntrega")}</strong>{" "}
                      {order.date ? `${order.date.getDate()}/${order.date.getMonth() + 1}/${order.date.getFullYear()}` : "Erro"}
                    </p>
                    <p>
                      <strong>{t("pedidos.formaPagamento")} </strong>
                      {order.paymentMethod === "pix"
                        ? t("accountMenu.pix")
                        : order.paymentMethod === "credit_card"
                          ? t("accountMenu.creditCard")
                          : t("accountMenu.billed")}
                    </p>
                    <p>
                      <strong>{t("pedidos.statusPagamento")} </strong>
                      {order.status === "PAYED"
                        ? t("pedidos.status-PAYED")
                        : order.status === "PAYMENT_PENDING"
                          ? t("pedidos.status-PAYMENT_PENDING")
                          : order.status === "CANCELED"
                            ? t("pedidos.status-CANCELED")
                            : order.status === "RECEIVED"
                              ? t("pedidos.status-RECEIVED")
                              : order.status === "SEPARATE"
                                ? t("pedidos.status-SEPARATE")
                                : t("pedidos.status-SENT")
                      }
                    </p>
                    <p>
                      <strong>{t(`accountMenu.address`)}:</strong>
                      {!order.address ? <span className={styles.addressInfoContainer}>Endereço indisponível</span> : <span className={styles.addressInfoContainer}>
                        <span>{order.address.name || "ERRO: endereço indisponível"}</span>
                        <span>
                          {order.address.street || "ERRO: endereço indisponível"},{" "}
                          {order.address.number || "-"}{" - "}
                          {order.address.district || "-"}
                        </span>
                        {order.address.complement ? (
                          <span>{order.address.complement}</span>
                        ) : (
                          ""
                        )}
                        <span>
                          {order.address.city || "-"}, {order.address.state || "-"}{" "}
                          {order.address.zipCode || "-"}
                        </span>
                      </span>}
                    </p>
                    <p>
                      <strong>{t(`accountMenu.type`)}: </strong>
                      {order.typeDelivery === "DELIVERY" ? t("accountMenu.delivery") : t("accountMenu.pickup")}
                    </p>
                    <p>
                      <strong>{t("pedidos.total")}:</strong> R${" "}
                      {currencyLocalFormat(order.price)}
                    </p>

                    {order.type === "pickup" && (
                      <button
                        onClick={() => {
                          setShowModalConfirmPickup(true);
                          setOrderToConfirmPickup(order);
                        }}
                        className={styles.confirmPickupButton}
                      >
                        {t("accountMenu.confirmPickup")}
                      </button>
                    )}
                  </div>

                  <div className={styles.buttonsContainer} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem 0', alignItems: 'stretch', padding: '0 16px', justifyContent: 'center' }}>
                    <button className={styles.invoiceButton}>
                      {t("pedidos.notaFiscal")}
                    </button>
                    {order.status !== "RECEIVED" ? <select
                      name="statusSelected"
                      className={styles.selectStatusOrder}
                      value={order.status}
                      onChange={(e) => {
                        const selectedValue = e.currentTarget.value
                        setOrders((prevValue) => {
                          const aux = [...prevValue]
                          aux[index].status = selectedValue
                          
                          api.put(`/order/status/${order.id}?status=${selectedValue}`)

                          return aux
                        })

                      }}
                    >
                      <option hidden={order.status !== 'PAYMENT_PENDING'} value="">
                        {t(`pedidos.status-${order.status}`)}
                      </option>
                      {order.status !== "PAYMENT_PENDING"
                        && order.status !== "RECEIVED"
                        && orderStatus.map(status => (
                          <option
                            key={status}
                            value={status}
                          >
                            {t(`pedidos.status-${status}`)}
                          </option>
                        ))}
                    </select> : <span>Pedido recebido</span>}
                  </div>
                </div>
                <button
                  className={styles.showProductList}
                  onClick={() => handleToggleShowProducts(index)}
                >
                  {showProductList[index] ? (
                    <MdExpandLess size={45} />
                  ) : (
                    <MdExpandMore size={45} />
                  )}
                </button>
                {showProductList[index] && (
                  <div className={styles.productsOuterContainer}>
                    <h2>{t(`accountMenu.orderProducts`)}</h2>
                    <div className={styles.productsInnerContainer}>
                      {order.product_order?.length > 0 ? (
                        order.product_order.map((productOrder: { product: Produto; id: Key | null | undefined; amount: number }) => {
                          if (!productOrder.product) {
                            // Produto inválido, exiba uma mensagem ou pule
                            return (
                              <p key={productOrder.id || Math.random()}>
                                {t('produtosIndisponivel')}
                              </p>
                            );
                          }
                          return (
                            <ProdutoItem
                              key={productOrder.id}
                              entrepreneurView
                              produto={productOrder.product}
                              amount={productOrder.amount}
                              onRemove={() => { }}
                            />
                          );
                        })
                      ) : (
                        <p>{t("pedidos.produtosIndisponiveis")}</p>
                      )}

                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </>
        <ModalConfirmarRetirada
          isOpen={showModalConfirmPickup}
          handleCancel={() => setShowModalConfirmPickup(false)}
          handleYes={handleConfirmPickup}
          order={orderToConfirmPickup ?? null}
        />
      </div>
    </div>
  );
};

export default EntrepreneurAccountOrders;
